import { memo } from "react"
import { makeStyles } from "tss-react/mui"
import { LocalizedStrict } from "../../../../../../../localization/components/AppLocalized"
import { ApiQueryAutocomplete } from "../../../../../../../../core/api/components/ApiQueryAutocomplete"
import { useApiQuery } from "../../../../../../../../core/api/useApiQuery"
import { fetchResources, FetchResourcesResponse, ServiceCenterResourcesQuery } from "../../../resourcesApi"
import { useAppSelector } from "../../../../../../../store/storeHooks"
import { selectServiceCenterId } from "../../../../../../../login/loginSelectors"
import { CreateRoomResourceForm, OrganizationResourceUnion, ResourceType } from "../../../resourcesTypes"
import { useFormikContext } from "formik"

const useStyles = makeStyles()((_theme) => ({
    input: {
        backgroundColor: "white",
    },
}))

const transformData = (data: FetchResourcesResponse) => data.resources

export const AVEquipmentSelector = memo(() => {
    const { classes } = useStyles()
    const serviceCenterId = useAppSelector(selectServiceCenterId)
    const { setFieldValue, values } = useFormikContext<CreateRoomResourceForm>()

    const {
        data: resourcesData = [],
        isLoading,
        isError,
    } = useApiQuery(fetchResources, {
        queryName: ServiceCenterResourcesQuery.SERVICE_CENTER_RESOURCES,
        dependencies: {
            serviceCenterId: serviceCenterId ?? 0,
            type: ResourceType.MOBILE_AV,
        },
        select: transformData,
    })

    const handleChange = (_event: React.SyntheticEvent, value: any) => {
        setFieldValue("roomDetails.avEquipments", value)
    }

    return (
        <>
            <LocalizedStrict id="resources-create-room-tab-general-fixed-av-equipment-label" attrs={{ label: true }}>
                <ApiQueryAutocomplete
                    isLoading={isLoading}
                    isError={isError}
                    options={resourcesData}
                    value={values.roomDetails?.avEquipments}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    getOptionLabel={(option) => option.name}
                    onChange={handleChange}
                    label="Fixed AV equipment"
                    multiple
                    slotProps={{
                        textField: { className: classes.input },
                        errorSelect: { className: classes.input },
                    }}
                />
            </LocalizedStrict>
        </>
    )
})
